import type { CDedicatedContactFormTranslations } from "./pl";

export const de: CDedicatedContactFormTranslations = {
  noConfig: "Formular-Konfigurationsdaten fehlen.",
  crmModeWithoutModule: {
    body1: "Das Formular ist auf CRM-Versand konfiguriert, aber das Modul",
    moduleName: "m_crm_sales_support",
    body2:
      'ist in dieser Domain nicht aktiv. Aktiviere das Modul im Admin-Panel oder ändere den Versandmodus auf "E-Mail" in der Katalogkonfiguration.',
  },
  unknownSendMode: (mode) =>
    `Unbekannter Versandmodus in der Formular-Konfiguration: ${mode}.`,

  contactUsingForm: "Kontaktformular",
  labels: {
    text: "Nachricht",
    subject: "Worum geht Ihre Anfrage?",
    subjectPlaceholder: "- auswählen -",
  },
  send: "Senden",
  sending: "Wird gesendet…",

  sectionHeaders: {
    personal: "Persönliche Daten",
    company: "Firmendaten",
  },

  validation: {
    requiredField: (label) => `Feld "${label}" ist erforderlich.`,
    invalidEmail: "Ungültige E-Mail-Adresse.",
    invalidUrl: "Die URL muss mit http:// oder https:// beginnen.",
    invalidPhone: "Ungültige Telefonnummer.",
    invalidNip: "Die Steuernummer muss 10 Ziffern haben.",
    requiredText: 'Das Feld "Nachricht" ist erforderlich.',
    requiredPersonalData:
      "Die Einwilligung zur Verarbeitung personenbezogener Daten ist erforderlich.",
  },

  map: {
    directionsLink: "Wegbeschreibung ->",
    openInOpenStreetMap: "In OpenStreetMap öffnen ->",
  },

  status: {
    waitBeforeSubmit: (seconds) =>
      `Bitte warte noch ${seconds} Sekunden, bevor du absendest.`,
    rateLimit:
      "Zu viele Versuche von dieser IP-Adresse. Versuche es in Kürze erneut.",
    sendFailed: "Die Nachricht konnte nicht gesendet werden.",
    sendSuccess: "Nachricht gesendet, danke!",
    networkError: (message) => `Netzwerkfehler: ${message}`,
    networkErrorGeneric: "Netzwerkfehler beim Senden.",
  },
};
